export function Button({
  variant = "outline",
  size = "md",
  className = "",
  ...props
}) {
  const base =
    "inline-flex items-center justify-center rounded-xl border font-medium transition duration-150 " +
    "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-dulia-gold/50 focus-visible:ring-offset-2 " +
    "disabled:cursor-not-allowed disabled:opacity-50 " +
    "dark:focus-visible:ring-offset-dulia-night";

  const variants = {
    primary:
      "border-dulia-navy bg-dulia-navy text-white shadow-soft hover:bg-dulia-navyAlt " +
      "dark:border-dulia-gold dark:bg-dulia-gold dark:text-dulia-night dark:hover:bg-dulia-goldSoft",

    outline:
      "border-dulia-line bg-dulia-panel text-dulia-navy hover:bg-dulia-parchment " +
      "dark:border-dulia-lineStrong/40 dark:bg-dulia-nightSoft dark:text-dulia-parchment dark:hover:bg-dulia-night",

    ghost:
      "border-transparent bg-transparent text-dulia-navy hover:bg-dulia-parchment/80 " +
      "dark:text-dulia-parchment dark:hover:bg-dulia-nightSoft",

    danger:
      "border-dulia-danger bg-dulia-danger text-white hover:opacity-90 " +
      "dark:border-dulia-danger dark:bg-dulia-danger dark:text-white",
  };

  const sizes = {
    sm: "px-2.5 py-1.5 text-sm",
    md: "px-3.5 py-2 text-sm",
    lg: "px-4.5 py-2.5 text-base",
  };

  return (
    <button
      className={`${base} ${variants[variant] || variants.outline} ${sizes[size] || sizes.md} ${className}`}
      {...props}
    />
  );
}

export default Button;
